<template><!-- Dit is een uitgeklede versie van de huispagina, bedoeld voor fotografen -->
  <v-app id="onHsfo">   
    <defNavBar title="Ares - Accommodation" type="photographer" v-if=!loading />
    <v-main>       
      <v-container fluid>   
        <v-row cols="12" v-if="!loading">  
          
          <v-col cols="12" class="px-1"> <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="8" class="px-1">
                  <v-card>                      
                    <v-card-title>Accommodation {{ hsfo.huis_code }} - {{ hsfo.huis_naam }}
                    </v-card-title>
                    <v-card-subtitle>{{hsfo.cttptaal_oms}}</v-card-subtitle>
                    <v-container>
                    <v-row no-gutters>
                      <v-col cols="12" class="px-1">
                        <v-card flat></v-card>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="2" class="px-1">
                        <v-card flat>Bedrooms: {{ hsfo.bedrooms }}</v-card>
                      </v-col>
                      <v-col cols="2" class="px-1">
                        <v-card flat>Sleeps: {{ hsfo.beds }}</v-card>
                      </v-col>
                      <v-col cols="2" class="px-1">
                        <v-card flat>Bathrooms: {{ hsfo.bathrooms }}</v-card>
                      </v-col>
                    </v-row>
                  </v-container>  
                  </v-card>
                </v-col>
              </v-row>
              
                <v-row>
                  <v-col cols="8" class="px-1">
                    <v-card>
                      <v-card-title>Planning Unit {{ planCode }} {{ hspl.plan_ical }} {{ hspl.huis_codes }}
                        <v-btn class="mx-3" :disabled="getPlan.jaar === new Date().getFullYear() - 2"
                          @click="getPlanning(planCode, getPlan.jaar - 1)" x-small
                          color="primary"><v-icon>mdi-chevron-left</v-icon></v-btn>
                        {{ getPlan.jaar }}
                        <v-btn class="mx-3" :disabled="getPlan.jaar === new Date().getFullYear() + 2"
                          @click="getPlanning(planCode, getPlan.jaar + 1)" x-small
                          color="primary"><v-icon>mdi-chevron-right</v-icon></v-btn>
                        {{ hspl.plan_to_code }} {{ hspl.plan_to_naam }}
                        <v-spacer></v-spacer>
                        <v-btn class="primary ma-2" x-small @click="showLegend = !showLegend">Legend</v-btn>
                      </v-card-title>
                      <v-container>
                        <v-row>
                          <v-col cols="1" v-show="moreThan1HsplRecord">
                            <div class="red--text" style="font-size: 12px">{{ hspl.huis_is_combi }}</div>
                            <table border="0" cellspacing="0" cellpadding="0" class="huisHspl">
                              <tr v-for="huisHspl in hsfo.hspl" :key="huisHspl.plan_code">
                                <td @click="getPlanning(huisHspl.plan_code, getPlan.jaar)" style="font-size: 12px">
                                  {{ huisHspl.plan_code }}</td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col cols="11">
                            <table border="0" cellspacing="0" cellpadding="0">
                              <tr v-for="planMaand in getPlan.planMaanden" :key="planMaand.maand">
                                <td style="font-size: 12px">{{ planMaand.maand }}</td>
                                <td @click="clickPlan(planRecord.datum, planRecord.tabel, planRecord.encrid)"
                                  :class="[planRecord.achtergrond, planRecord.gewicht, planRecord.fontkleur]"
                                  v-for="planRecord in planMaand.maandDagen" :key="planRecord.dag">{{ planRecord.dag }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-row>
                        <v-col cols="1"></v-col>
                        <v-col cols="11" style="display: flex; flex-direction: row; gap: 20px;">
                          <div>
                            Rent License: {{ hspl.plan_verhvergun_stat }} {{ hspl.plan_verhvergun_ref }}
                          </div>
                          <div>
                            Energy Label: {{ hspl.plan_energie_label }}
                          </div>
                          <div v-if="hspl.plan_operto_id !== ''">
                            Operto: {{ hspl.plan_operto_id }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-container class="pl-8 pr-8" v-if="showLegend">
                          <div style="display: flex; flex-direction: row; align-items: center;">
                            <div>Legend</div> <v-divider class="ml-2 mr-2"></v-divider>
                          </div>
                          <div
                            style="display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: space-between; padding-top: 10px; padding-bottom: 10px; padding-left: 20px">
                            <div v-for="legendaRecord in legenda.legenda" :key="legendaRecord.achtergrond"
                              style="display: flex; flex-direction: row; padding-top: 5px; padding-bottom: 10px; width: 275px; ">
                              <div :class="legendaRecord.achtergrond"></div>
                              <div class="ml-2">{{ legendaRecord.oms }}</div>
                            </div>
                          </div>
                        </v-container>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="4" class="px-1">
                    <v-card>
                      <v-card-title>Contact Info
                        <v-spacer></v-spacer>
                        
                      </v-card-title>
                      <v-container fluid id="fotoContainer"> 
                        <v-row>
                          <v-col cols="12">
                              <p>{{ hsfo.hsct[0].eign_naam }}<br>
                              {{ hsfo.hsct[0].eign_adres }}<br>
                              {{ hsfo.hsct[0].eign_postcode }}, {{ hsfo.hsct[0].eign_plaats }}, {{ hsfo.hsct[0].eign_land_code }}<br>
                              <a :href="'mailto:' + hsfo.hsct[0].eign_email">{{ hsfo.hsct[0].eign_email }}</a><br>
                              {{ hsfo.hsct[0].eign_telefoon }}</p>
                    
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>

                </v-row>
            </v-container>
          </v-col>
          <v-col cols="12" class="px-1">
                      <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>                      
                    <v-card-title>Photograph Request details {{ hsfo.huis_code }}</v-card-title>
                    <v-card-subtitle></v-card-subtitle>
                    <v-container>
                      <v-row>  
                        <v-col cols="2"><b>Status</b></v-col>
                        <v-col cols="4">
                          <v-select v-model="hsfo.hsfo_status" :items="hsfo.hsfo_statusKeuzes" item-text="oms" item-value="value" >
                                  <template v-slot:item="data">
                                    <v-chip :color='statuscolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                                  </template>
                                  <template v-slot:selection="data">
                                    <v-chip :color='statuscolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                                  </template>
                                  <template v-slot:append-outer>
                                    <v-btn v-if="hsfo.hsfo_status !== 'Completed' || (hsfo.hsfo_status === 'Completed' && hsfo_status_after_save == '')" color="secundary" @click="updHsfo()">Update</v-btn>
                                  </template>
                                </v-select>
                        
                        </v-col>
                        <v-col cols="2">Priority</v-col>
                        <v-col cols="4"><v-chip :color='priocolor[hsfo.hsfo_prio]'>{{ hsfo.hsfo_prio }}</v-chip></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="2">Request date</v-col>
                        <v-col cols="4">{{ hsfo.hsfo_inv_dat }}</v-col>  
                        <v-col cols="2">Deadline</v-col>
                        <v-col cols="4">{{ hsfo.hsfo_deadline }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="2">Country</v-col>
                        <v-col cols="4">{{ hsfo.huis_land_code }}</v-col>
                        <v-col cols="2">Accommodation address</v-col>
                        <v-col cols="4">{{ hsfo.huis_postcode }} <br> {{ hsfo.huis_adres }} <br> {{ hsfo.huis_plaats }} </v-col>
                      </v-row>
                      <v-row> 
                        <v-col cols="2">Contact</v-col>
                        <v-col cols="4" v-for="(hsct, hsctidx) in hsfo.hsct " :key="hsctidx">
                          Name: {{ hsct.eign_naam }} <br>
                          Role: {{ hsct.hsct_rol }}
                        </v-col>
                        <v-col cols="2">Rental agent</v-col>
                        <v-col cols="4"> {{ hsfo.gebr_name }} </v-col>
                      </v-row>
                      <v-row>
                        <v-col><b>Tasks</b></v-col>
                      </v-row>
                      <v-row>
                        <v-col v-for="(hfot, hfotidx) in hsfo.hfot" :key="hfotidx">
                          <v-card>
                            <v-card-title>{{ hfot.hfot_type }}</v-card-title>
                            <v-container>
                            
                            
                            <v-row>
                              <v-col cols="12">
                                <v-select v-model="hfot.hfot_status" :items="hsfo.hfot_statusKeuzes" item-text="oms" item-value="value" >
                                  <template v-slot:item="data">
                                    <v-chip :color='statuscolor_hfot[data.item.value]'>{{ data.item.oms }}</v-chip>
                                  </template>
                                  <template v-slot:selection="data">
                                    <v-chip :color='statuscolor_hfot[data.item.value]'>{{ data.item.oms }}</v-chip>
                                  </template>
                                  <template v-slot:append-outer>
                                    <v-btn v-if="hsfo.hsfo_status !== 'Completed' || (hsfo.hsfo_status === 'Completed' && hsfo_status_after_save === '')" color="secundary" @click="updHfot(hfot.hfot_encrid,hfot.hfot_status)">Update</v-btn>
                                  </template>
                                </v-select>

                                <!-- <v-chip :color='statuscolor_hfot[hfot.hfot_status]'>{{ hfot.hfot_status }}</v-chip> -->
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                {{ hfot.hfot_deadline }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                {{ hfot.hfot_oms }}
                              </v-col>
                            </v-row>
                          </v-container>
                          </v-card>

                        </v-col>
                        
                      </v-row>
                      <v-row>
                        <!-- attachments? -->
                      </v-row>
                      
                    </v-container>  
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
            </v-col>



          <v-col cols="12" class="px-1"> <!-- Rechts -->
            <v-container>
              <v-row>
                <v-col cols="8" class="px-1">
                  <v-card>
                  <v-card-title>Photos &nbsp;
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="primary" @click="updateData()" v-bind="attrs" v-on="on">mdi-reload</v-icon>
                      </template>
                      <span>Reload photo's</span>
                    </v-tooltip>
                    <v-dialog v-if="hsfo.hsfo_status === 'Assigned'" v-model="dialog" width="1250">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="primary ma-2" v-bind="attrs" v-on="on">
                          Add photo's
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                          Add photo's
                        </v-card-title>
                        <div class="pa-5">
                          <HsftDropzonePhp :huis-row-id="hsfo.huis_encrid" :gebr-encrid="getCurrentUser()" :huis-nr="hsfo.huis_nr" :upload-url="hsfo.hsft_upload_url" />
                        </div>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" @click="dialog = false; updateData()">
                            Close
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-btn v-if="hsfo.huis_media === 'Yes' && hsfo.hsft_processing && hsfo.hsfo_status === 'Assigned'"
                          class="primary ma-2"  @click="viewProcessingHsft(hsfo.huis_encrid)">Upload Errors</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-container fluid id="fotoContainer"> 
                    <v-row>
                      <v-col cols="12" md="4" >
                        
                    </v-col>
                    </v-row>
                    
                    <v-row v-if="hsfo.huis_media === 'Yes'" no-gutters>
                  <v-col v-for="p in hsfo.hsft_aant" :key="p" id="content" class="d-flex child-flex ma-2" cols=2>
                      <figure :class="(hsfo.hsft[parseInt(p) - 1].fttgtaal_oms !== '' && hsfo.hsft[parseInt(p) - 1].hsft_status == 'Live') ? hsfo.hsft[parseInt(p) - 1].hsft_status : (hsfo.hsft[parseInt(p) - 1].fttgtaal_oms == '' && hsfo.hsft[parseInt(p) - 1].hsft_status !== 'Live') ? hsfo.hsft[parseInt(p) - 1].hsft_status : (hsfo.hsft[parseInt(p) - 1].fttgtaal_oms !== '' && hsfo.hsft[parseInt(p) - 1].hsft_status !== 'Live') ? hsfo.hsft[parseInt(p) - 1].hsft_status : 'LiveNoTag'">
                        
                        <img :src="hsfo.hsft[parseInt(p) - 1].hsft_foto" class="px-1"  @click="updHsft(hsfo.hsft[parseInt(p) - 1].hsft_encrid)" :title="hsfo.hsft[parseInt(p) - 1].hsft_tag">
                        <figcaption>
                            {{hsfo.hsft[parseInt(p) - 1].hsft_nr}} {{ hsfo.hsft[parseInt(p) - 1].hsft_tag }}
                            <v-row>
                              <v-col cols="12">
                              <v-chip outlined x-small color="warning" v-if="hsfo.hsft[parseInt(p) - 1].uploadedbyuser" size=30 class="mx-1"><v-icon left x-small>mdi-camera</v-icon>Uploaded by you</v-chip>
                              <v-avatar color="error" v-if="hsfo.hsft[parseInt(p) - 1].hsft_portrait" size=30 class="mx-1">Portr</v-avatar>
                              <v-avatar color="error" v-if="hsfo.hsft[parseInt(p) - 1].hsft_size_red" size=30 class="mx-1">Size</v-avatar>
                              <v-avatar color="warning" v-if="hsfo.hsft[parseInt(p) - 1].hsft_size_orange" size=30 class="mx-1">Size</v-avatar>
                              <v-chip x-small color="error" v-if="hsfo.hsft[parseInt(p) - 1].hsft_no_tag" size=30 class="mx-1">Add photo tag!</v-chip>
                              <v-avatar color="warning" v-if="hsfo.hsft[parseInt(p) - 1].hsft_not_43" size=30 class="mx-1">4:3</v-avatar>
                              <v-avatar color="warning" v-if="hsfo.hsft[parseInt(p) - 1].hsft_not_unique" size=30 class="mx-1">Uniq</v-avatar>
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col cols="10">
                                </v-col>
                              <v-col cols="2">
                                <v-btn v-if="hsfo.hsft[parseInt(p) - 1].uploadedbyuser" icon small color="error" @click="delHsft(hsfo.hsft[parseInt(p) - 1].hsft_encrid, parseInt(p) - 1, hsfo.hsft[parseInt(p) - 1].hsft_grote_foto)"><v-icon>mdi-trash-can</v-icon></v-btn>
                              </v-col>
                            </v-row>
                        </figcaption>
                      </figure>  
                      </v-col>
                  </v-row>
                  </v-container>
                   <addHsft2 ref="addHsft2"></addHsft2>
                   <orderHsft ref="orderHsft"></orderHsft>
                   <viewDelHsft ref="viewDelHsft"></viewDelHsft>
                   <viewProcessingHsft ref="viewProcessingHsft"></viewProcessingHsft>
                   <copyHsft ref="copyHsft"></copyHsft>
                   <updHsft ref="updHsft"></updHsft>
                   <delHsft ref="delHsft" @updateData="updateData"></delHsft>
                   <bulkDelHsft ref="bulkDelHsft" />                       
                  </v-card>
                </v-col>
                <v-col>
                  <!--
                  <v-card>
                    <v-card-title>Actions
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-container fluid id="fotoContainer"> 
                      <v-row>
                        <v-col cols="12" md="4" >
                          Input text
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  -->
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-row v-else style="display: flex; flex-direction: column; align-items: center">   
          <v-progress-circular :width="3" :size="20" color="success" indeterminate style="margin-top: 50px;"></v-progress-circular>
          <div class="mx-auto">Loading...</div>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>




<script>
import addHsft2 from "@/views/huis/hsft/addHsft2.vue";
import orderHsft from "@/views/huis/hsft/orderHsft.vue";
import viewDelHsft from "@/views/huis/hsft/viewDelHsft.vue";
import copyHsft from "@/views/huis/hsft/copyHsft.vue";
import updHsft from "@/views/huis/hsft/updHsftHsfo.vue";
import bulkDelHsft from "@/views/huis/hsft/bulkDelHsft.vue"
import viewProcessingHsft from "@/views/huis/hsft/viewProcessingHsft.vue";
import delHsft from "@/views/huis/hsft/delHsft.vue";

import HsftDropzonePhp from '@/components/huis/hsft/HsftDropzone6php.vue';
import mxauthorization from '@/mixins/authorization';

import defNavBar from '@/components/ui/navbars/navbar.vue';


import {bus} from "../../main";

 export default {
  components: {
    addHsft2,
    orderHsft,
    viewDelHsft,
    delHsft,
    viewProcessingHsft,
    copyHsft,
    updHsft,
    bulkDelHsft,
    HsftDropzonePhp,
    defNavBar
  },
  props: ['huis_encrid','hsfo_encrid'],
  mixins:[mxauthorization], 
  data() {
    return {
      loading: false,
      hsfo: {
        huis_code: '',
        huis_combi: '',
        action_items: [],  /* moet pre defined ivm length check */
        hsabCurrent: [], /* moet pre defined ivm length check */
        hsabExpired: [], /* moet pre defined ivm length check */
        hfot_statusKeuzes : [],
        planCode: '',
        hsfo_status: '',
        hsct: [{
          eign_naam: '',
          eign_adres: '',
          eign_postcode: '',
          eign_plaats: '',
          eign_email: '',
          eign_telefoon: '',
          eign_land_code: ''
        }],

      },
      hsfo_status_after_save: '',
      moreThan1HsplRecord: false,
      getPlan: {},
      legenda: {},
      planCode: '',
      hspl: {},
      dialog: false,
      showLegend: false,
      priocolor: {
        Low: '#D1E2FF',
        Medium: '#74EBE1',
        High: '#DC043B'
      },
      statuscolor: {
        Signedup: '#FAD2FC',
        Readytoshoot: '#FFEAB6',
        Offered: '#D1E2FF',
        Assigned: '#88DBFF',
        Completed: '#9AE095',
        Rejected: '#41454D',
        Onhold: '#FFB68E'
      },
      statuscolor_hfot: {
        Notapplicable: '#DC043B',
        Pending: '#D1E2FF',
        Completed: '#9AE095'
      }
    }
  },
  mounted() {
  },
  created() {
    bus.$on("closeDialog", (data) => {
      console.log(data);
      if(data==='reload'){
        this.getHuisData('closedialog');
      }
    });  
    this.getHuisData('created');      
  },
  computed: {
    filtered_thpgp: function () {
      return this.thpgp.filter((gp) => {
          console.log(gp, this.hpgp_periodetype)
          if (this.hpgp_periodetype===null) {
            return true;
          } else {
            if (gp.hpgp_periodtype===this.hpgp_periodetype) {
              return true;
            }
          }
          return false;
      })
    }    
  },        
  methods: {
    getHeaders(){
      return [
          { text: "Source", sortable: false},
          { text: "Reviews", sortable: false, align: "end"},
          { text: "Average", sortable: false, align: "end"},
          { sortable: false, align: "start"}
        ];
    },    
    updateData(){
      this.getHuisData('update');
    }, 
    updateData2(data){
      this[data.field]=data.value;
    },        
    getHuisData(hook){ 
      console.log(hook)
      this.getLegenda();
      this.$axios
        .post("ares/json/ares/huis/hsfo/getHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsfo"
          },
          getHsfo: {
            hsfo_encrid: this.hsfo_encrid
          }
        })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
          this.loading = false
        } else {
           this.hsfo = res.data.getHsfo;
           this.planCode = this.hsfo.hspl[0].plan_code;
           if (res.data.getHsfo.hspl.length > 1) this.moreThan1HsplRecord = true;
           this.getPlanning(this.hsfo.hspl[0].plan_code, new Date().getFullYear());
           document.title = 'Acco ' + res.data.getHsfo.huis_code;
           this.loading = false;
           if (this.hsfo.hsfo_status === 'Completed') {
              this.hsfo_status_after_save = this.hsfo.hsfo_status;
           }
        }
      });
    },
    getLegenda() {
      this.$axios
        .post("ares/json/ares/huis/hspl/getLegenda.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getLegenda"
          },
          getLegenda: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.legenda = res.data.getLegenda;
          }
        })
    },
    getPlanning(planCodePar, jaar) {
      this.$axios
        .post("ares/json/ares/huis/hspl/getPlan.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getPlan"
          },
          getPlan: {
            huis_code: this.hsfo.huis_code,
            plan_code: planCodePar,
            jaar: jaar
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.getPlan = res.data.getPlan;
            this.planCode = planCodePar;
            this.hspl.plan_to_code = res.data.getPlan.plan_to_code;
            this.hspl.plan_to_naam = res.data.getPlan.plan_to_naam;
            this.hspl.plan_ical = res.data.getPlan.plan_ical;
            this.hspl.huis_codes = res.data.getPlan.huis_codes;
            this.hspl.huis_is_combi = res.data.getPlan.huis_is_combi;
            this.hspl.plan_verhvergun_ref = res.data.getPlan.plan_verhvergun_ref;
            this.hspl.plan_verhvergun_stat = res.data.getPlan.plan_verhvergun_stat;
            this.hspl.plan_energie_label = res.data.getPlan.plan_energie_label;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    winterfoto() {
      this.$axios
        .post("ares/json/ares/huis/updHuisWinterFoto.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHuisWinterFoto"
          },
          updHuisWinterFoto: {
            huis_encrid: this.huis_encrid,
            huis_winter_foto_volgorde: this.hsfo.huis_winter_foto_volgorde
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            //this.$router.reload('/huis/onHuis/' + res.data.updHuisWinterFoto.huis_encrid); 
            this.getHuisData('winterfoto');
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHuisWinterFoto.text,
              color: res.data.updHuisWinterFoto.color
            });
          }
        })
    },
    updHfot(hfot_encrid,hfot_status) {
      this.$axios
        .post("ares/json/ares/huis/hsfo/updHfot.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHfot"
          },
          updHfot: {
            hsfo_encrid: this.hsfo_encrid,
            hfot_encrid: hfot_encrid,
            hfot_status: hfot_status
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHfot.text,
              color: res.data.updHfot.color
            });
          }
        })
    },
    updHsfo() {
      this.$axios
        .post("ares/json/ares/huis/hsfo/updHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHsfo"
          },
          updHsfo: {
            hsfo_encrid: this.hsfo_encrid,
            hsfo_status: this.hsfo.hsfo_status,
            hsfo: this.hsfo

          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHsfo.text,
              color: res.data.updHsfo.color
            });
            this.hsfo_status_after_save = this.hsfo.hsfo_status;
            this.hsfo.hsfo_statusKeuzes = res.data.updHsfo.hsfo_statusKeuzes;
          }
        })
    },
    addHsft2(huis_encrid) {
       this.$refs.addHsft2.open(huis_encrid);
    },
    bulkDelHsft(hsfo) {
       this.$refs.bulkDelHsft.openDialog(hsfo);
    },
    delHsft(photoid,index,hsft_grote_foto){
      this.$refs.delHsft.open(photoid,index,hsft_grote_foto);  
    },
    orderHsft(huis_encrid,summer_winter) {
       this.$refs.orderHsft.open(huis_encrid,summer_winter);
    },
    viewDelHsft(huis_encrid){
       this.$refs.viewDelHsft.open(huis_encrid);
    },
    copyHsft(hsfo) {
      this.$refs.copyHsft.open(hsfo);
    },
    updHsft(hsft_encrid,hsfo_encrid) {
       this.$refs.updHsft.open(hsft_encrid,hsfo_encrid);
    },
    getAuth(login_user){
      return localStorage.getItem('login')===login_user
    },
    getCurrentUser() {
      return localStorage.getItem('login')
    },
    viewProcessingHsft(huis_encrid) {
      this.$refs.viewProcessingHsft.open(huis_encrid);
    },    
  }
};

</script> 
<style src="@/assets/plan.css"></style>
<style>
.br_small{
   display: block;
   margin-bottom: 0em;
}
.br_medium {
    display: block;
    margin-bottom: 1em;
}  
.br_large {
    display: block;
    margin-bottom: 2em;
}
.vet {
  font-weight: bold;
  font-size: 200;
}
.normaal {
  font-weight: 200;
  font-size: small;
}
.zwart {
  color: black;
}
.wit {
  color: white;
  font-weight: bold;
}
.huisHspl tr:hover {
  background-color: #1976D2; /* primary coplor */
  color: white;
}
.welTekst {
  color: #4CAF50;  /* success */
  text-align: center;
}
.geenTekstError {
  color: #FF5252; /* error */
  text-align: center;
}
.geenTekst {
  color: #000000; /*  */
  text-align: center;
}
#content figcaption {
  font-size: 11px;
  text-shadow: none;
  color: black;
  height: auto;
  word-wrap: break-word;
  width: 120px;
}
.ptr {
  cursor: pointer;
}
.text-field-style >>> .v-text-field__slot input {
    color: grey;
    font-weight: 300; /* 800 being bold so this is less than half bold */
}    
.text-grey {
    color: grey !important;
    font-weight: 400 !important; /* 800 being bold so this is half bold */
}    
.hsipline_markup{
  margin-top: 8px;
  font-size: 11pt !important;
}
.flex{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.last-item {
    margin-left: auto;
}
.column{
  position: inherit;
  width: 20%;
}
.col-value{
  float:right; 
  font-weight: bold; 
  padding-right: 40px;
}
.noborder {
    border: 0px !important; 
    /* height: 12px !important; */
}
.onlyborder {
    height: 2px !important;
}
.detail {
    height: 12px !important;
}
.thgp-select{
  margin-left: 18px;
  width: 300px !important;
}
.table-header{
  font-weight: 700;
}
.Live {
        background-color: rgb(218, 255, 218) !important;
        border-radius:10px;
    }
    .Offline {
        background-color: rgb(212, 212, 212) !important;
        border-radius:10px;
    }
    .Deleted {
        background-color: rgb(212, 212, 212) !important;
        border-radius:10px;
    }
    .LiveNoTag {
        background-color: rgb(255, 211, 169) !important;
        border-radius:10px;
    }
</style>
 